/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MetaInputs */



/**
* | output |
* | --- |
* | "Meta" |
*
* @param {Nav_MetaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_meta = /** @type {((inputs?: Nav_MetaInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MetaInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Meta")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Méta")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("环境")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("Meta")
	if (locale === "ko") return /** @type {LocalizedString} */ ("메타")
	return /** @type {LocalizedString} */ ("Meta")
});